class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.maxItems = parseInt(this.dataset.maxItems) || 8;
    this.currentHandle = this.dataset.currentHandle;
    this.storageKey = 'recently_viewed_products';
  }

  connectedCallback() {
    this.list = this.querySelector('.recently-viewed__list');
    this.prevBtn = this.querySelector('.recently-viewed__arrow--prev');
    this.nextBtn = this.querySelector('.recently-viewed__arrow--next');

    this.trackCurrentProduct();
    this.renderProducts();

    // Event listeners
    this.prevBtn?.addEventListener('click', () => this.scroll(-1));
    this.nextBtn?.addEventListener('click', () => this.scroll(1));
  }

  trackCurrentProduct() {
    let viewed = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
    viewed = viewed.filter(h => h !== this.currentHandle);
    viewed.unshift(this.currentHandle);
    if (viewed.length > this.maxItems) viewed = viewed.slice(0, this.maxItems);
    localStorage.setItem(this.storageKey, JSON.stringify(viewed));
  }

  async renderProducts() {
    let viewed = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
    viewed = viewed.filter(h => h !== this.currentHandle);

    const cards = await Promise.all(viewed.map(this.fetchProductCard));
    const html = cards.filter(Boolean).join('');
    
    if (html) {
      this.list.innerHTML = html;
      this.closest('.recently-viewed-wrapper').classList.remove('hidden');
      
      if (window.innerWidth >= 768) {
        this.checkScrollButtons();
        this.list.addEventListener('scroll', () => this.checkScrollButtons());
      }
  
      setTimeout(() => {
        this.reinitializeSwymButtons();
      }, 100);
    } else {
      this.closest('.recently-viewed-wrapper').classList.add('hidden');
    }
  }

  async fetchProductCard(handle) {
    try {
      const res = await fetch(`/products/${handle}?view=card`);
      if (!res.ok) return '';
      return await res.text();
    } catch (e) {
      console.error(e);
      return '';
    }
  }

  scroll(direction) {
    const scrollAmount = this.list.clientWidth;
    this.list.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
  }

  checkScrollButtons() {
    const maxScroll = this.list.scrollWidth - this.list.clientWidth;
    const currentScroll = this.list.scrollLeft;

    this.prevBtn.style.display = currentScroll > 0 ? 'flex' : 'none';
    this.nextBtn.style.display = currentScroll < maxScroll - 10 ? 'flex' : 'none';
  }

  reinitializeSwymButtons() {
    if (!window.SwymCallbacks) return;

    window.SwymCallbacks.push(function(swat) {
      swat.initializeActionButtons();
    });

    // Si ya está cargado, vuelve a llamar el init
    if (window._swat && typeof window._swat.initializeActionButtons === 'function') {
      window._swat.initializeActionButtons();
    }
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);
